import { render, staticRenderFns } from "./CookieNotice.vue?vue&type=template&id=35de2aae&"
import script from "./CookieNotice.vue?vue&type=script&lang=js&"
export * from "./CookieNotice.vue?vue&type=script&lang=js&"
import style0 from "./CookieNotice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports